import tElse from 'volta/helpers/t-else';
import BvStatus from 'volta/components/bv-status';
import BaseCell from './base-cell';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellStatusCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellStatusCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='status-cell'
    as |baseCell|
  >
    {{#if baseCell.value}}
      <BvStatus
        @status={{tElse baseCell.value.label}}
        @color={{baseCell.value.color}}
        @abbreviated={{baseCell.value.abbreviated}}
        @temporary={{baseCell.value.temporary}}
        @tooltip={{baseCell.value.tooltip}}
      />
    {{/if}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellStatusCellSignature>;

export default CellStatusCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::StatusCell': typeof CellStatusCellComponent;
    'cell/status-cell': typeof CellStatusCellComponent;
  }
}
